import sidebar from '@/config/sidebars/gsc_ga4'
import createVueApp from '@/common/create_app'

Styxie.Initializers.GscGa4Ga4Pages = {
  index: async(props) => {
    const { default: Ga4PagesIndex } = await import('@/vue_widgets/gsc_ga4/ga4_pages/index.vue')
    createVueApp(Ga4PagesIndex, { props, sidebar })
  }
}
